import moment from 'moment/moment'
import React from 'react'
import ReactPaginate from 'react-paginate'

const NotificationTable = ({ history, keyword, setKeyWord, total, size, handlePageClick, offset, handleView }) => {

  return (
    <div>
      <div className="border rounded-md bg-white">
        <div className="flex justify-between items-center px-6 py-3 border-b">
          <h2 className="text-xl font-semibold">Notification History</h2>
          <input type="text" placeholder="Search" value={keyword} onChange={(e) => setKeyWord(e.target.value)} className="px-2 py-1 border border-[#D8D8D8] rounded focus:outline-none focus:ring" />
        </div>
        <div className="overflow-x-auto p-6">
          <table className="min-w-full text-sm text-left text-gray-500  border ">
            <thead className="text-black capitalize border-b bg-gray-100">
              <tr className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">#</th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">Notification ID</th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">Type</th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">Title</th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">Status</th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">Sent Date & Time</th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">Action</th>
              </tr>
            </thead>
            <tbody>
              {history && history?.length > 0 ? history?.map((item, index) => (
                <tr key={index} className="bg-white whitespace-nowrap hover:bg-gray-50 font-normal text-[#212121] border-b capitalize">
                  <td className="px-4 py-2 whitespace-nowrap">{offset + index + 1}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{item.id}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{item.type === 1 ? 'User' : 'Customer'}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{item.title}</td>
                  <td className="px-4 py-2 whitespace-nowrap">
                    <span
                      className={`py-1 px-2 rounded text-white ${item.status === 1 ? 'bg-green-500' : 'bg-red-500'}`}
                    >
                      {item.status === 1 ? 'Sent' : "Failed"}
                    </span>
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap">{moment(item.created_at).format('YYYY-MM-DD / hh:mm A')}</td>
                  <td className="px-4 py-2 whitespace-nowrap">
                    <button className="text-blue-500 hover:underline" onClick={() => handleView(item)}>View</button>
                  </td>
                </tr>
              )) : (<div className='w-full text-center'>No Data Found</div>)}
            </tbody>
          </table>
        </div>
        {total && total > size && <div className='p-4 pt-6'>

          <ReactPaginate
            previousLabel={'Prev'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={total / size}
            marginPagesDisplayed={1}
            pageRangeDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            pageClassName={'page-cls'}
            activeClassName={'active'}
            total={total}
            size={size}
          />
        </div>}

      </div>
    </div>
  )
}

export default NotificationTable